<div class="container">
  <div class="row">
    <div class="col s6 text-align-left">
      <a class="btn btn-outline" type="button" [routerLink]="url">
        Back to frame catalog
      </a>
    </div>
    <h1>{{ pageTitle }}</h1>
  </div>
</div>
